import { useSocialSignIn } from '@/features/login/hooks';
import { LoginPageTemplate } from './ui';

export const LoginPage = () => {
  const { signInLoading, onSignInWithGoogleClick, onSignInWithMicrosoftClick } = useSocialSignIn();

  return (
    <LoginPageTemplate
      title="Get started"
      description="Get insight with your social data instantly."
      signInLoading={signInLoading}
      onSignInWithGoogleClick={onSignInWithGoogleClick}
      onSignInWithMicrosoftClick={onSignInWithMicrosoftClick}
    />
  );
};
